import { render, staticRenderFns } from "./BuildingSelector.vue?vue&type=template&id=d6a201b4"
import script from "./BuildingSelector.vue?vue&type=script&lang=ts"
export * from "./BuildingSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports